// The legal information of a company as its forms edit it: the
// « Informations légales » modal and « Modifier l'entreprise »
// (CompanyEditPanel) read and write it the same way.

export const STATUS_LIST = [
  { value: null, label: 'Choisir' },
  { value: 'SAS', label: 'SAS' },
  { value: 'SASU', label: 'SASU' },
  { value: 'SARL', label: 'SARL' },
  { value: 'EURL', label: 'EURL' },
  { value: 'SEARL', label: 'SEARL' },
  { value: 'EI', label: 'EI' },
  { value: 'SAI', label: 'SAI' },
  { value: 'GIE', label: 'GIE' },
  { value: 'SCI', label: 'SCI' },
  { value: 'SCOP', label: 'SCOP' },
  { value: 'SICA', label: 'SICA' },
  { value: 'SMIA', label: 'SMIA' },
  { value: 'SNC', label: 'SNC' },
  { value: 'Association', label: 'Association' },
  { value: 'Administration', label: 'Administration' },
  { value: 'Société étrangère', label: 'Société étrangère' },
  { value: 'AUTRES', label: 'AUTRES' },
];

export const draftFromCompany = (companyInfo) => ({
  reason_social: companyInfo?.reason_social ?? '',
  name_commercial: companyInfo?.name_commercial ?? '',
  address: companyInfo?.address ?? null,
  siret: companyInfo?.siret ?? '',
  status: companyInfo?.status ?? null,
  code_ape: companyInfo?.code_ape ?? '',
  staff: companyInfo?.staff ?? '',
  capital: companyInfo?.capital ?? '',
  conv_collective: companyInfo?.conv_collective ?? null,
  companySupplier: companyInfo?.companySupplier?._id?.toString() ?? null,
});

// The share capital as typed: null when emptied, NaN when it is not an amount
// of euros (negative or not a number).
export const parseCapital = (value) => {
  const typed = String(value ?? '').trim();
  if (!typed) return null;
  const amount = Number(typed.replace(',', '.'));
  return Number.isFinite(amount) && amount >= 0 ? amount : NaN;
};

export const isCapitalValid = (draft) =>
  !Number.isNaN(parseCapital(draft?.capital));

// The capital as postUpdateCompanyOverview takes it: a number, or null to clear
// it. Compared as numbers, so "1000" typed over 1000 is no change.
export const diffCapital = (draft, companyInfo) => {
  const capital = parseCapital(draft?.capital);
  if (Number.isNaN(capital)) return {};
  return capital === (companyInfo?.capital ?? null) ? {} : { capital };
};

// Companies carry INSEE wordings the hardcoded list never had ("SA à conseil
// d'administration (s.a.i.)"). Without its own option the select falls back
// to "Choisir", and a filled field reads as empty.
export const statusOptionsOf = (companyInfo) =>
  !companyInfo?.status || STATUS_LIST.some((option) => option.value === companyInfo.status)
    ? STATUS_LIST
    : [...STATUS_LIST, { value: companyInfo.status, label: companyInfo.status }];

// The collective agreements as the form lists them. Read and write use
// different keys on purpose: the company record stores the IDCC number, which
// is what `checked` matches, while the update endpoint takes the Mongo id and
// resolves the IDCC itself.
export const agreementsOf = (data, companyInfo) =>
  (Array.isArray(data) ? data : []).map((item) => ({
    id: item._id,
    name: `${item.IDCC_id} - ${item.IDCC_name}`,
    checked: parseInt(companyInfo?.conv_collective) === parseInt(item.IDCC_id),
  }));
